import {JOURNAL_TYPES} from "./journal";

export const ROUTE_PATH: any = {
  // common
  ERROR_PAGE: '/404',
  AUTH: '/auth',
  RESTORE: '/restore',
  PROFILE: '/profile',
  MAIN: '/',
  NOTIFICATION: '/notification',
  HELP: '/help',
  REPORT: '/report',
  CURATING: '/curating',

  // journal
  JOURNAL: '/journal',
  JOURNAL_CURRENT: '/journal/:id',
  JOURNAL_CURRENT_INNER: '/journal/:id/inner',

  JOURNAL_SDOT: `/journal/sdot/:id`,
  JOURNAL_SDOT_TEST_VIEW: `/journal/sdot/:id/:testId`,

  // plans.ts
  PLANS: '/plans',
  PLANS_VIEW: '/plans/:ctpId',
  LESSON_VIEW: '/plans/:ctpId/:lessonId',
  LESSON_TEST: '/plans/:ctpId/:lessonId/tests/:testId',
  LESSON_TEST_VIEW: '/plans/:ctpId/:lessonId/tests/:testId/view',

  // schedule
  SCHEDULE: '/schedule',

  PRINT_JOURNAL: '/print-journal',

  STUDENTS_SCHEDULE: '/student-schedule',
  STUDENTS_SCHEDULE_PLAN: '/student-schedule/:lessonId',
  STUDENTS_SCHEDULE_PLAN_TEST: '/student-schedule/:lessonId/test/:testId',
  STUDENTS_SCHEDULE_PLAN_TEST_VIEW: '/student-schedule/:lessonId/test/:testId/view',

  // rup
  RUP: '/rup',
  RUP_QUALIFICATION: '/rup/:rupId',
  RUP_QUALIFICATION_TABLE: '/rup/:rupId/table',

  //record
  RECORD: '/record',

  LIBRARY: '/library',
  LIBRARY_CURRENT: '/library/:subjectId',
  LIBRARY_CURRENT_TEST: '/library/:subjectId/test/:testId',
  LIBRARY_CURRENT_TEST_VIEW: '/library/:subjectId/test/:testId/view',

  EXAM: '/exam',
  EXAM_PLAN: '/exam/:lessonId',

  //entrant
  ENTRANT_REGISTER: "/entrant-register",
  ENTRANT_INFO: "/entrant-info",
  ENTRANT_PROFESSIONAL_ORIENTATION_TEST: "/entrant-test",
  ENTRANT_ADMISSION: "/entrant-admission",
  ENTRANT_ADMISSION_WITHOUT_RANKING: "/entrant-admission-without-ranking",
  ENTRANT_ADMISSION_ACCEPT_REJECT: "/entrant-admission-accept-reject/:id",
  ENTRANT_ADMISSION_ACCEPT_REJECT_NOTE: "/entrant-admission-accept-reject/:id/note",
  ENTRANT_ADMISSION_VIEW: "/entrant-admission-view",
  ENTRANT_USER_APPLICATIONS: "/entrant-user-applications",
  ENTRANT_USER_APPLICATIONS_CURRENT: "/entrant-user-applications/:id",
  ENTRANT_ADMISSION_LOG: "/entrant-admission-log/:id",
  ENTRANT_EDUCATION_ORDERS: "/entrant-education-orders",
  MEDICAL_ROOM: "/medical-room",
  MEDICAL_ROOM_APPEAR_VIEW: "/medical-room/appear/:id",


  USER_ORDER_LEAVE: "/user-order/leave/:id",

  PSYCHOLOGIST: "/psychologist",
  PSYCHOLOGIST_VIEW: "/psychologist/:id",
  PSYCHOLOGIST_WORK_VIEW: "/psychologist/worksubtab/:id"
}
